import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const showMaybe = /* #__PURE__ */ (() => {
  const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
  return {
    show: v => {
      if (v.tag === "Just") { return "(Just " + $0(v._1) + ")"; }
      if (v.tag === "Nothing") { return "Nothing"; }
      $runtime.fail();
    }
  };
})();
const fieldLabelIsSymbol = {reflectSymbol: () => "fieldLabel"};
const fieldNameIsSymbol = {reflectSymbol: () => "fieldName"};
const internalIsSymbol = {reflectSymbol: () => "internal"};
const messageIsSymbol = {reflectSymbol: () => "message"};
const ordMaybe = /* #__PURE__ */ Data$dMaybe.ordMaybe(/* #__PURE__ */ Data$dOrd.ordArray(Data$dOrd.ordString));
const eqMaybe = /* #__PURE__ */ (() => {
  const $0 = Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
  return {
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return $0(x._1)(y._1); }
        return false;
      }
      return false;
    }
  };
})();
const arrayEncode = {encode: /* #__PURE__ */ Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce)};
const arrayDecode = /* #__PURE__ */ Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode);
const asJSONKeyMaybe = /* #__PURE__ */ Data$dMap$dSerialized.asJSONKeyMaybe(arrayEncode)(arrayDecode);
const arrayEncode1 = /* #__PURE__ */ (() => (
  {
    encode: Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(messageIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(internalIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(fieldNameIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return arrayEncode.encode(v2._1); }
        $runtime.fail();
      }
    }))(fieldLabelIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))
  }
))();
const arrayDecode1 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.arrayDecode({
  decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(messageIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.readString
  })())(internalIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode})())(fieldNameIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(arrayDecode.decode)
  })())(fieldLabelIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)})()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
}))();
const FormErrors = x => x;
const showFormErrors = /* #__PURE__ */ Data$dMap$dInternal.showMap(showMaybe)({
  show: /* #__PURE__ */ Data$dShow.showArrayImpl(record => {
    if (record.fieldLabel.tag === "Just") {
      return "{" + " fieldLabel: (Just " + Data$dShow.showStringImpl(record.fieldLabel._1) + ")" + ", fieldName: " + showMaybe.show(record.fieldName) + (record.internal
        ? ", internal: true, message: " + Data$dShow.showStringImpl(record.message) + " "
        : ", internal: false, message: " + Data$dShow.showStringImpl(record.message) + " ") + "}";
    }
    if (record.fieldLabel.tag === "Nothing") {
      return "{ fieldLabel: Nothing, fieldName: " + showMaybe.show(record.fieldName) + (record.internal
        ? ", internal: true, message: " + Data$dShow.showStringImpl(record.message) + " "
        : ", internal: false, message: " + Data$dShow.showStringImpl(record.message) + " ") + "}";
    }
    $runtime.fail();
  })
});
const semigroupFormErrors = {append: v => v1 => Data$dMap$dInternal.unsafeUnionWith(ordMaybe.compare, Data$dFunction.const, v, v1)};
const newtypeFormErrors_ = {Coercible0: () => {}};
const monoidFormErrors = /* #__PURE__ */ (() => ({mempty: Data$dMap$dInternal.monoidMap(ordMaybe).mempty, Semigroup0: () => semigroupFormErrors}))();
const eqFormErrors = /* #__PURE__ */ Data$dMap$dInternal.eqMap(eqMaybe)({
  eq: /* #__PURE__ */ Data$dEq.eqArrayImpl(ra => rb => (() => {
    if (ra.fieldLabel.tag === "Nothing") { return rb.fieldLabel.tag === "Nothing"; }
    if (ra.fieldLabel.tag === "Just") {
      if (rb.fieldLabel.tag === "Just") { return ra.fieldLabel._1 === rb.fieldLabel._1; }
      return false;
    }
    return false;
  })() && eqMaybe.eq(ra.fieldName)(rb.fieldName) && ra.internal === rb.internal && ra.message === rb.message)
});
const encodeFormErrors = /* #__PURE__ */ (() => (
  {
    encode: Data$dMap$dSerialized.encodeMap(asJSONKeyMaybe)(arrayEncode1)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", arrayEncode1.encode(v)), Data$dList$dTypes.Nil)
    }).encode
  }
))();
const decodeFormErrors = {
  decode: /* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(ordMaybe)(asJSONKeyMaybe)(arrayDecode1)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => arrayDecode1.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode;
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
      if ($1.tag === "Right") { return Data$dEither.$Either("Right", $1._1); }
      $runtime.fail();
    };
  })()
};
const userVisibleErrors = errors => Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  Data$dMaybe.Nothing,
  Data$dFunctor.arrayMap(message => ({fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message, internal: false}))(errors),
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
);
const userVisibleError = message => userVisibleErrors([message]);
const isEmpty = v => v.tag === "Leaf";
const internalErrorForField = fieldName => message => Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  Data$dMaybe.$Maybe("Just", fieldName),
  [{fieldName: Data$dMaybe.$Maybe("Just", fieldName), fieldLabel: Data$dMaybe.Nothing, message, internal: true}],
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
);
const internalError = message => Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  Data$dMaybe.Nothing,
  [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message, internal: true}],
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
);
const unknownError = /* #__PURE__ */ Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  Data$dMaybe.Nothing,
  [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: "Unknown error", internal: true}],
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
);
const formErrorsToArray = x => Data$dArray.concat(Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr, x));
export {
  FormErrors,
  arrayDecode,
  arrayDecode1,
  arrayEncode,
  arrayEncode1,
  asJSONKeyMaybe,
  decodeFormErrors,
  encodeFormErrors,
  eqFormErrors,
  eqMaybe,
  fieldLabelIsSymbol,
  fieldNameIsSymbol,
  formErrorsToArray,
  internalError,
  internalErrorForField,
  internalIsSymbol,
  isEmpty,
  messageIsSymbol,
  monoidFormErrors,
  newtypeFormErrors_,
  ordMaybe,
  semigroupFormErrors,
  showFormErrors,
  showMaybe,
  unknownError,
  userVisibleError,
  userVisibleErrors
};
